import { QueryClient } from '@tanstack/react-query';
import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import { getSession, useSession } from 'next-auth/react';
import { useEffect } from 'react';

import BackgroundBlobs from '../components/_molecules/BackgroundBlobs/BackgroundBlobs';
import useSignIn from '../hooks/useSignIn';
import { detectAndBestEffortSetLanguage } from '../utils/localisationUtils';
import { dehydrateReactQueryPrefetchedInfiniteQuery } from '../utils/react-query-utils';
import { provisionFlags } from '../utils/ServerSideFeatureFlagUtils';

const Login = () => {
  const { signIn } = useSignIn();
  const session = useSession();
  const router = useRouter();
  const sessionStatus = session.status;
  useEffect(() => {
    if (session.status === 'unauthenticated') {
      signIn({ callbackUrl: '/' });
    }
    if (session.status === 'authenticated') {
      router.push('/');
      return;
    }
  }, [router, session, sessionStatus, signIn]);
  return (
    <>
      <BackgroundBlobs />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async context => {
  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=300, stale-while-revalidate=3600',
  );
  const session = await getSession({ req: context.req });

  if (session) {
    // If user is already authenticated, redirect to home
    return {
      redirect: {
        permanent: false,
        destination: `/`,
      },
    };
  } else {
    // If user is not authenticated, show the login page with all necessary props
    const queryClient = new QueryClient();
    const flags = await provisionFlags(context, queryClient, session);
    //if there is no access to the flag, redirect to the lessons page
    return {
      props: {
        ...flags,
        dehydratedState: dehydrateReactQueryPrefetchedInfiniteQuery(queryClient),
        ...(await detectAndBestEffortSetLanguage(context)),
        session,
      },
    };
  }
};

export default Login;
